<ui-headline
  [type]="type"
  [mobile-type]="type"
  font-weight="semibold"
  [text-color]="textColor"
>
  {{ text }}
</ui-headline>
